import { NavigateOptions, Path, useNavigate } from 'react-router-dom';
import { checkIsAppPage } from 'tools/loaction';

export const useMiNavigation = () => {
    const navigate = useNavigate();

    const isAppPage = checkIsAppPage();
    if (isAppPage)
        return (newLocation: string | number | Partial<Path>, options?: NavigateOptions) => {
            if (typeof newLocation === 'number') {
                history.go(newLocation);
            } else {
                if (options?.replace) {
                    window.location.replace(String(newLocation));
                } else {
                    window.location.href = String(newLocation);
                }
            }
        };

    return navigate;
};
